import { Component, OnInit, ElementRef, Renderer, ViewChild, ChangeDetectorRef, ViewEncapsulation} from '@angular/core';
import { PopupService } from '../../services/popup.service';
import { UserService } from '../../services/user.service';
import { NotificationService } from '../../services/notification.service';
import { environment } from '../../../environments/environment';
import { Router } from "@angular/router";
import { BrandingService } from '../../services/branding.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileComponent implements OnInit {

  constructor(public popupService: PopupService, public userService: UserService,
              public notificationService: NotificationService, public  renderer: Renderer,
              public router: Router, public ref: ChangeDetectorRef, public brandingService: BrandingService) { }

  @ViewChild('fileInput') fileInput: ElementRef;

  ngOnInit() {}

  logout() {
    let w = (<any>window);   
    w.mmap.disableMasterMapMode(); 
    this.userService.logout().subscribe();
    this.router.navigate(['/map']);
    this.userService.organizationName = null;
    w.Events.publish('detectChanges');
  }

  getCompanySettings() {
    let w = (<any>window);
    if(this.checkJllUser()) {
      w.open(environment.APP.JLL.WEB_APP_URL +'org-admin')
    } else {
      w.open(environment.APP.TOURS_WEB_APP_URL +'org-admin');
    }
  }

  checkJllUser() {
    if(this.userService.loggedIn) {
      return this.userService.loggedInUser.brandingInfo && this.userService.loggedInUser.brandingInfo.brandingKey === 'jll';
    } else {
      return this.brandingService.isJllSite();
    }
  }

  changeProfilePic(event) {
    let fileList: FileList = event.target.files;
    if(fileList[0].type.includes('image')) {
      this.userService.updateUserProfilePic(fileList[0]).subscribe((response)=>{
        this.userService.loggedInUser.photoMediaId = new Date().getTime();
        this.notificationService.info('Your profile picture has been updated.');
        (<any>window).Events.publish('detectChanges');
      },
      (error)=>{
        throw error;
      });
    } else {
      this.notificationService.error('Please upload a valid image')
    }
  }

  deleteUserPhoto() {
    this.userService.updateUser({
      id: this.userService.user.userId,
      mediaId : null
    }).subscribe((result) => {
      this.userService.user.mediaId = null;
      this.userService.loggedInUser.photoMediaId = null;
      this.notificationService.info('Your profile picture has been deleted.');
      (<any>window).Events.publish('detectChanges');
    });
  }

  showImageBrowseDlg() {
    let event = new MouseEvent('click', { bubbles: false });
    this.renderer.invokeElementMethod(
        this.fileInput.nativeElement, 'dispatchEvent', [event]);
  }

  changePassword(e) {
    e.stopPropagation();
    this.router.navigate(['/map/reset-password'], {queryParams: {passwordChange: true}})
  }

  toggleAdminMode() {
    let w = (<any>window);
    w.mmap && w.mmap.toggleAdminMode(!w.mmap.adminMode);    
    this.router.navigate(['/map']);
    this.userService.organizationName = null;
    w.Events.publish('detectChanges');
  }

  getContactSupportEmail() {
    return this.userService.loggedIn && this.userService.loggedInUser.brandingInfo && this.userService.loggedInUser.brandingInfo.brandingKey === 'jll' ? environment.APP.JLL.SUPPORT_EMAIL : environment.APP.SUPPORT_EMAIL;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/profile/profile.component.ts